// DS: CR36
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { formatDate, DATE_FORMATS } from '@wix/da-ds/pkg/Time/functions';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { default as HomeIcon } from '@wix/da-ds/pkg/Icons/24x24/Home';
import PlusIcon from '@wix/da-ds/pkg/Icons/Plus';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { ResourceType } from '../types/resource';
import Button from '../Button';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './MiniGroupCard.scss';
export const MiniGroupCard = ({ group: { user , user: { usericon: imageUrl , username , details , stats ={
    watchers: 0,
    friends: 0
} , profile , userId  } , description  } , style , dataHook , className  })=>{
    const { t , i18n  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const defaultGroupAvatar = 'https://a.deviantart.net/avatars-big/default_group.gif';
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className),
        style: isMobile ? _object_spread_props(_object_spread({}, style), {
            height: undefined
        }) : style,
        "data-hook": dataHook
    }, /*#__PURE__*/ React.createElement(BiLink, {
        href: Url.userLink(username),
        title: username,
        biData: BiData({
            evid: 100,
            itemid: userId,
            typeid: ResourceType.GROUP,
            page_typeid: BiContextProvidedValue,
            page_itemid: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            widgetname: BiContextProvidedValue
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['inner']
    }, imageUrl && imageUrl !== defaultGroupAvatar ? /*#__PURE__*/ React.createElement("img", {
        loading: "lazy",
        className: s['group-image'],
        src: imageUrl,
        alt: username,
        "aria-hidden": true
    }) : /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['group-image'], s['no-image']),
        "aria-hidden": true
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['group-name'],
        title: username
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['group-name-text']
    }, username), /*#__PURE__*/ React.createElement(HomeIcon, {
        className: s['group-name-icon'],
        customSizable: true,
        "aria-hidden": true
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['group-description'],
        title: profile && profile.tagline
    }, profile && profile.tagline), /*#__PURE__*/ React.createElement("div", {
        className: s['group-stats']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['watchers']
    }, t('miniGroupCard.watchers', {
        formattedCount: shortenNumber(stats.watchers),
        count: stats.watchers
    })), /*#__PURE__*/ React.createElement("span", {
        className: s['stat-separator'],
        "aria-hidden": true
    }, "|"), /*#__PURE__*/ React.createElement("div", {
        className: s['created-date']
    }, t('miniGroupCard.dateCreated', {
        date: details ? formatDate(details.joindate, DATE_FORMATS.Date.MonthYear, i18n.language) : ''
    }))), /*#__PURE__*/ React.createElement(Button, {
        className: s['join-button'],
        view: "b16-undisciplined-designers",
        href: Url.userLink(username),
        "aria-hidden": true
    }, /*#__PURE__*/ React.createElement(PlusIcon, {
        size: IconSize.NANO,
        disableDefaultColors: true,
        className: s['plus-icon']
    }), t('miniGroupCard.joinGroup')))));
};
MiniGroupCard.displayName = 'MiniGroupCard';
export default MiniGroupCard;
